/** Retirement is authoritative; a stopped source keeps only saved, active articles. */
export const inLibrary = (saved: boolean, deleted: boolean, retired: boolean) =>
  !retired && (saved || !deleted);

/** Keep the current page, or continue forwards, then backwards at the end; close an empty session. */
export function remainingSession(id: string, ids: readonly string[], gone: ReadonlySet<string>): { id: string; session: string[] } | null {
  const session = ids.filter((id) => !gone.has(id));
  const next = session.includes(id) ? id : ids.slice(ids.indexOf(id) + 1).find((id) => !gone.has(id)) ?? session.at(-1);
  return next ? { id: next, session } : null;
}
